<template>
  <header
    id="site-header"
    class="site-header"
    :class="{ open: isOpen }"
  >
    <div class="content-max-width">

      <a href="/" class="logo">
        <img src="/images/logo.jpg" alt="ECB Vet logo" />
      </a>

      <div class="right">
        <a :href="data.phone_url" class="tel">{{ data.phone }}</a>

        <a
          v-if="facebook"
          :href="facebook"
          target="_blank" class="fb"
        >
          <img src="/images/fb.png" alt="ECB Vet Facebook">
        </a>

        <a
          v-if="data.header_btn_link"
          :href="data.header_btn_link"
          class="button" target="_blank"
        >
          {{ data.header_btn_title }}
        </a>

        <button class="hamburger mobile" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

    </div>

    <nav>
      <ul class="top">
        <li v-for="(link, index) of nav" :key="index">
          <a :href="link.url">
            {{ link.title }}
          </a>
        </li>
        <li class="fb-menu">
          <a :href="facebook" target="_blank">
            <img src="/images/fb.png" alt="ECB Vet Facebook">
          </a>
        </li>
      </ul>
    </nav>

  </header>
</template>

<script>
export default {
  props: {
    menu: Array,
    data: Object,
    facebook: String
  },

  data: () => ({
    isOpen: false,
    nav: []
  }),

  mounted () {
    this.nav = this.menu
    console.log(this.$parent.menu)
  },

  methods: {
    toggleMenu () {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>
